// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"868ded46","453":"a9bb6eee","796":"a5c5081f"}[chunkId] + ".chunk.js";
};